import { useEffect, useState } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#event', label: "L'Événement" },
    { href: '#tradition', label: 'La Tradition' },
    { href: '#lieu', label: 'Le Lieu' },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-cream/95 backdrop-blur-md shadow-elegant py-2'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo section */}
          <div className="flex-shrink-0">
            <img
              src="/logo_ufe.png"
              alt="UFE - Union des Français de l'Etranger"
              className={`h-12 w-auto transition-all duration-300 ${
                isScrolled ? '' : 'brightness-0 invert'
              }`}
            />
          </div>

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`relative font-serif text-sm tracking-wide transition-colors duration-300 group ${
                  isScrolled
                    ? 'text-navy-700 hover:text-navy-900'
                    : 'text-cream/80 hover:text-cream'
                }`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-1 left-0 w-0 h-px transition-all duration-300 group-hover:w-full ${
                    isScrolled ? 'bg-gold' : 'bg-gold/70'
                  }`}
                />
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <a
              href="#rsvp"
              className={`hidden sm:inline-flex items-center gap-2 px-6 py-2.5 font-serif font-medium text-sm tracking-wide transition-all duration-300 ${
                isScrolled
                  ? 'bg-burgundy text-cream hover:bg-burgundy-dark'
                  : 'bg-gold text-navy-900 hover:bg-gold-light'
              }`}
            >
              Je participe
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden p-2 transition-colors ${
                isScrolled ? 'text-navy-900' : 'text-cream'
              }`}
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className={`py-4 space-y-1 border-t ${isScrolled ? 'border-cream-dark' : 'border-cream/20'}`}>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 font-serif text-base transition-colors ${
                  isScrolled
                    ? 'text-navy-700 hover:text-navy-900'
                    : 'text-cream/80 hover:text-cream'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#rsvp"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-3 font-serif font-medium text-gold"
            >
              Je participe
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
